// extracted by mini-css-extract-plugin
export default {"reportTagRouteSection":"styles_reportTagRouteSection__LRUPE","nameTitle":"styles_nameTitle__Lj-N5"};